export default {
  'common': {
    'add': 'Добавить',
    'cancel': 'отменить',
    'description': 'Описание',
    'delete': 'удалять',
    'title': 'заглавие',
    'save': 'Сохранить',
    'faq': 'часто задаваемые вопросы',
    'contact': 'Связаться с нами',
    'tos': 'условия обслуживания',
    'policy': 'политика конфиденциальности'
  },
  'board': {
    'titlePlaceholder': 'Введите название для этой карты',
    'deleteDescription': 'Вы уверены, что хотите удалить эту карту?',
    'editCard': 'Изменить карту',
    'deleteCard': 'Удалить карту',
    'state': {
      'TODO': 'ДЕЛАТЬ',
      'INPROGRESS': 'В ХОДЕ ВЫПОЛНЕНИЯ',
      'TESTING': 'ТЕСТИРОВАНИЕ',
      'DONE': 'СДЕЛАННЫЙ'
    }
  },
  'chat': {
    'online': 'Пользователи в сети ({count})',
    'addChannel': 'Добавить канал',
    'channel': 'Канал | каналы',
    'message': 'Сообщение'
  },
  'email': {
    'compose': 'Написать письмо',
    'send': 'послать',
    'subject': 'Тема',
    'labels': 'Этикетки',
    'emptyList': 'Пустой список рассылки',
    'inbox': 'Входящие',
    'sent': 'Отправлено',
    'drafts': 'Черновики',
    'starred': 'Помечено',
    'trash': 'Мусор',
    'work': 'Работа',
    'invoice': 'Выставленный счет'
  },
  'todo': {
    'addTask': 'Добавить задачу',
    'tasks': 'Задания',
    'completed': 'Завершено',
    'labels': 'Этикетки'
  },
  'dashboard': {
    'activity': 'Деятельность',
    'weeklySales': 'Еженедельные продажи',
    'sales': 'Продажи',
    'recentOrders': 'Недавние заказы',
    'sources': 'Источники трафика',
    'lastweek': 'по сравнению с прошлой неделей',
    'orders': 'Заказы',
    'customers': 'Клиенты',
    'tickets': 'Тикеты поддержки',
    'viewReport': 'Посмотреть отчет'
  },
  'usermenu': {
    'profile': 'Профиль',
    'signin': 'Войти в систему',
    'dashboard': 'Приборная доска',
    'signout': 'Выход'
  },
  'error': {
    'notfound': 'Страница не найдена',
    'other': 'Произошла ошибка'
  },
  'check': {
    'title': 'Установить новый пароль',
    'backtosign': 'Вернуться к входу',
    'newpassword': 'Новый пароль',
    'button': 'Установите новый пароль и войдите в систему',
    'error': 'Ссылка на действие недействительна',
    'verifylink': 'Проверка ссылки ...',
    'verifyemail': 'Проверка адреса электронной почты ...',
    'emailverified': 'Электронная почта подтверждена! Перенаправление ...'
  },
  'forgot': {
    'title': 'Забыли пароль?',
    'subtitle': 'Введите адрес электронной почты своей учетной записи, и мы отправим вам ссылку для сброса пароля.',
    'email': 'Эл. адрес',
    'button': 'Запросить сброс пароля',
    'backtosign': 'Вернуться к входу'
  },
  'login': {
    'title': 'Войти в систему',
    'email': 'Эл. адрес',
    'password': 'пароль',
    'button': 'Войти в систему',
    'orsign': 'Или войдите с помощью',
    'forgot': 'Забыли пароль?',
    'noaccount': 'Нет учетной записи?',
    'create': 'Создайте здесь',
    'error': 'Комбинация адреса электронной почты и пароля недействительна'
  },
  'register': {
    'title': 'Регистрация',
    'name': 'Полное имя',
    'email': 'Эл. адрес',
    'password': 'пароль',
    'button': 'Регистрация',
    'orsign': 'Или зарегистрируйтесь с',
    'agree': 'Регистрируясь, вы соглашаетесь с',
    'account': 'Уже есть аккаунт?',
    'signin': 'Войти в систему'
  },
  'utility': {
    'maintenance': 'В обслуживании'
  },
  'faq': {
    'call': 'Остались вопросы? Пожалуйста, протяни руку'
  },
  'ecommerce': {
    'products': 'Продукты',
    'filters': 'Фильтры',
    'collections': 'Коллекции',
    'priceRange': 'Ценовой диапазон',
    'customerReviews': 'Отзывы клиентов',
    'up': 'и вверх',
    'brand': 'Марка',
    'search': 'Искать продукт',
    'results': 'Результаты ({0} из {1})',
    'orders': 'Заказы',
    'shipping': 'Перевозка',
    'freeShipping': 'Бесплатная доставка',
    'inStock': 'В наличии',
    'quantity': 'Количество',
    'addToCart': 'Добавить в корзину',
    'buyNow': 'купить сейчас',
    'price': 'Цена',
    'about': 'Об этом товаре',
    'description': 'Описание',
    'reviews': 'Отзывы',
    'details': 'информация о продукте',
    'cart': 'Корзина',
    'summary': 'итог заказа',
    'total': 'Всего',
    'discount': 'Скидка',
    'subtotal': 'Промежуточный итог',
    'continue': 'Продолжить покупки',
    'checkout': 'Проверять, выписываться'
  },
  'menu': {
    'search': 'Поиск (нажмите \'ctrl + /\', чтобы сфокусироваться)',
    'dashboard': 'Приборная доска',
    'logout': 'Выйти',
    'profile': 'Профиль',
    'blank': 'Пустая страница',
    'pages': 'Страницы',
    'others': 'Другие',
    'email': 'Эл. адрес',
    'chat': 'Чат',
    'todo': 'Делать',
    'board': 'Доска задач',
    'users': 'Пользователи',
    'usersList': 'Список',
    'usersEdit': 'редактировать',
    'ecommerce': 'Электронная торговля',
    'ecommerceList': 'Продукты',
    'ecommerceProductDetails': 'информация о продукте',
    'ecommerceOrders': 'Заказы',
    'ecommerceCart': 'Корзина',
    'auth': 'Страницы аутентификации',
    'authLogin': 'Вход / Вход',
    'authRegister': 'Зарегистрироваться / Зарегистрироваться',
    'authVerify': 'Подтвердить Email',
    'authForgot': 'Забыли пароль',
    'authReset': 'Сброс пароля',
    'errorPages': 'Страницы ошибок',
    'errorNotFound': 'Не найдено / 404',
    'errorUnexpected': 'Неожиданно / 500',
    'utilityPages': 'Страницы служебных программ',
    'utilityMaintenance': 'Обслуживание',
    'utilitySoon': 'Скоро',
    'utilityHelp': 'FAQ / Помощь',
    'levels': 'Уровни меню',
    'disabled': 'Меню отключено',
    'docs': 'Документация',
    'feedback': 'Обратная связь',
    'support': 'Служба поддержки',
    'landingPage': 'Целевая страница',
    'pricingPage': 'Страница с ценами'
  },
  '$vuetify': {
    'badge': 'Значок',
    'close': 'Закрыть',
    'dataIterator': {
      'noResultsText': 'Совпадающих записей не найдено',
      'loadingText': 'Загрузка предметов ...'
    },
    'dataTable': {
      'itemsPerPageText': 'Строк на странице:',
      'ariaLabel': {
        'sortDescending': 'Сортировка по убыванию.',
        'sortAscending': 'Сортировка по возрастанию.',
        'sortNone': 'Не отсортировано.',
        'activateNone': 'Активируйте, чтобы убрать сортировку.',
        'activateDescending': 'Активируйте для сортировки по убыванию.',
        'activateAscending': 'Активируйте для сортировки по возрастанию.'
      },
      'sortBy': 'Сортировать по'
    },
    'dataFooter': {
      'itemsPerPageText': 'Пункты на странице:',
      'itemsPerPageAll': 'Все',
      'nextPage': 'Следующая страница',
      'prevPage': 'Предыдущая страница',
      'firstPage': 'Первая страница',
      'lastPage': 'Предыдущая страница',
      'pageText': '{0} - {1} из {2}'
    },
    'datePicker': {
      'itemsSelected': 'Выбрано {0}',
      'nextMonthAriaLabel': 'В следующем месяце',
      'nextYearAriaLabel': 'Следующий год',
      'prevMonthAriaLabel': 'Прошлый месяц',
      'prevYearAriaLabel': 'Предыдущий год'
    },
    'noDataText': 'Данные недоступны',
    'carousel': {
      'prev': 'Предыдущее изображение',
      'next': 'Следующий визуал',
      'ariaLabel': {
        'delimiter': 'Карусель слайд {0} из {1}'
      }
    },
    'calendar': {
      'moreEvents': 'Еще {0}'
    },
    'fileInput': {
      'counter': '{0} файлов',
      'counterSize': '{0} файлов (всего {1})'
    },
    'timePicker': {
      'am': 'AM',
      'pm': 'PM'
    },
    'pagination': {
      'ariaLabel': {
        'wrapper': 'Пагинационная навигация',
        'next': 'Следующая страница',
        'previous': 'Предыдущая страница',
        'page': 'Перейти к странице {0}',
        'currentPage': 'Текущая страница, страница {0}'
      }
    }
  }
}